import { render } from "./ProfileSettingView.vue?vue&type=template&id=b62bbc60"
import script from "./ProfileSettingView.vue?vue&type=script&lang=js"
export * from "./ProfileSettingView.vue?vue&type=script&lang=js"

import "./ProfileSettingView.vue?vue&type=style&index=0&id=b62bbc60&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__